import HomePage from "Pages/HomePage";

import UsersPage from "Pages/UsersPage";

import ContactUsPage from "Pages/ContactUsPage";

import TaxisPage from "Pages/TaxisPage";
import SheetOfTaxiPage from "Pages/SheetOfTaxiPage";
import EquipementsPage from "Pages/EquipementsPage";
import BadgesPage from "Pages/BadgesPage";
import TripsPage from "Pages/TripsPage";
import BookingPage from "Pages/BookingPage";
import InvoicePage from "Pages/InvoicesPage";
import BookingGuard from "Common/Guards/BookingGuard";
import StatisticsPage from "Pages/StatisticsPage";

const PAGE_ROUTES = [
  {
    path: "/home",
    element: <HomePage />,
  },
  {
    path: "/users",
    element: <UsersPage />,
  },
  {
    path: "/contact-us",
    element: <ContactUsPage />,
  },
  {
    path: "/taxis",
    element: <TaxisPage />,
  },
  {
    path: "/taxi/:code",
    element: <SheetOfTaxiPage />,
  },
  {
    path: "/equipements",
    element: <EquipementsPage />,
  },
  {
    path: "/badges",
    element: <BadgesPage />,
  },
  {
    path: "/trips",
    element: <TripsPage />,
  },
  {
    path: "/bookings",
    element: (
      <BookingGuard>
        <BookingPage />
      </BookingGuard>
    ),
  },
  {
    path: "/invoices",
    element: <InvoicePage />,
  },
  {
    path: "/statistics/trips",
    element: <StatisticsPage />
  },
  {
    path: "/statistics/recette",
    element: <StatisticsPage />
  }
];

export default PAGE_ROUTES;
